<template>
  <button
    class="link text-sm"
    :aria-label="`Nutrition info for ${ productTitle }`"
    data-gtm-action="show nutrition info"
    :data-gtm-label="productTitle"
    @click.prevent="handleClick"
  >
    {{ $t('bundler.nutrition_info') }}
  </button>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores'
import type { MediaImage } from '@/types/shopify'

const FidNutritionModal = () => import('./fid-nutrition-modal.vue')

const { modal } = useThemeStore()
const props = defineProps<{
  productTitle: string
  image?: MediaImage
  src?: string
  width?: number | string
  height?: number | string
  alt: string
}>()
const handleClick = () => modal.open(FidNutritionModal, props)
</script>
